import WorkContext from "@/components/commons/Work/WorkContext";
import OfficialLabelsState from "@/components/commons/Work/OfficialLabelsWork/OfficialLabelsState";
import Dictionary from "@/types/Dictionary";

/** 
 * Classe de base d'une déclinaison de Context par type de OfficialLabels
 * @description A utiliser si nécessité d'avoir des propriétés propres au OfficialLabels
 */
export default class OfficialLabelsContext extends WorkContext {
	/** Constructeur avec paramètres */
	public constructor(state: OfficialLabelsState, results: any, configs: Dictionary<any>, variant: string, showConfigButtons: boolean = false) {
		super(state, results, configs, variant, showConfigButtons);
	}
}